import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container container-trip-search d-flex flex-column" }
const _hoisted_2 = {
  class: "ml-5",
  for: "roundTrip"
}
const _hoisted_3 = {
  id: "main-transportation-title",
  class: "d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_4 = { class: "font-big mt-5 transportation-title" }
const _hoisted_5 = { class: "font-weight-600" }
const _hoisted_6 = { class: "transportation-tickets-container row row-cols-2" }
const _hoisted_7 = { class: "mt-5 d-flex flex-column align-items-start" }
const _hoisted_8 = { class: "transportation-routes-list-container d-flex flex-column align-items-center" }
const _hoisted_9 = {
  key: 0,
  class: "is-loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBoxComponent = _resolveComponent("CheckBoxComponent")!
  const _component_TransportationComponent = _resolveComponent("TransportationComponent")!
  const _component_TransportationTicketComponent = _resolveComponent("TransportationTicketComponent")!
  const _component_DatesSliderComponent = _resolveComponent("DatesSliderComponent")!
  const _component_AdditionalInfoCheckboxModal = _resolveComponent("AdditionalInfoCheckboxModal")!
  const _component_TransportationItemComponent = _resolveComponent("TransportationItemComponent")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_CheckBoxComponent, {
      onOnClick: _ctx.isRoundTrip,
      state: _ctx.roundTrip,
      id: 'roundTrip',
      name: "roundTrip",
      class: "checkbox-default mb-4"
    }, {
      "checkbox-text": _withCtx(() => [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('round_trip')), 1)
      ]),
      _: 1
    }, 8, ["onOnClick", "state"]),
    _createVNode(_component_TransportationComponent, {
      "round-trip": _ctx.roundTrip,
      onOnSearchSubmit: _ctx.onSearchSubmit
    }, null, 8, ["round-trip", "onOnSearchSubmit"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backEndErrorMessage, (error) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "custom-route-error-color font-small",
        key: error
      }, _toDisplayString(_ctx.$t(error)), 1))
    }), 128)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('passenger_transportation')), 1),
      _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.pickUp.address_to_show) + ", " + _toDisplayString(_ctx.pickUp.city) + " - " + _toDisplayString(_ctx.dropOff.address_to_show) + ", " + _toDisplayString(_ctx.dropOff.city), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_TransportationTicketComponent, {
        "is-forward-ticket": true,
        "display-props": { imgUrl: '/images/next-arrow.svg', placeholder: 'choose_ticket_forward' },
        "forward-ticket": _ctx.forwardTicket
      }, null, 8, ["forward-ticket"]),
      _createVNode(_component_TransportationTicketComponent, {
        "is-forward-ticket": false,
        "display-props": { imgUrl: '/images/previous-arrow.svg', placeholder: 'choose_ticket_back' },
        "back-ticket": _ctx.backTicket
      }, null, 8, ["back-ticket"])
    ]),
    _createVNode(_component_DatesSliderComponent, {
      "how-many-to-load": 6,
      "selected-date": _ctx.tripDepartureDate.toISOString(),
      "round-trip": _ctx.roundTrip,
      onSelectedDate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSelectDate($event)))
    }, null, 8, ["selected-date", "round-trip"]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_AdditionalInfoCheckboxModal, {
        id: 'additional-pickup-info',
        upperText: _ctx.$t('pickup_from_the_specified_address'),
        lowerText: _ctx.$t('enter_a_pickup_address'),
        labelText: _ctx.$t('pick_up_from_the_specified_address'),
        init_is_checked: _ctx.specifiedForwardTicketData.pickup_is_checked,
        init_address: _ctx.specifiedForwardTicketData.pickup_specified_address,
        init_note: _ctx.specifiedForwardTicketData.pickup_note,
        onChangedAddress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeAddress($event))),
        onChangedNote: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeNote($event)))
      }, null, 8, ["upperText", "lowerText", "labelText", "init_is_checked", "init_address", "init_note"]),
      _createVNode(_component_AdditionalInfoCheckboxModal, {
        class: "mt-2",
        id: 'additional-dropoff-info',
        upperText: _ctx.$t('dropoff_at_specified_address'),
        lowerText: _ctx.$t('enter_dropoff_address'),
        labelText: _ctx.$t('drop_off_at_specified_address'),
        init_is_checked: _ctx.specifiedForwardTicketData.dropoff_is_checked,
        init_address: _ctx.specifiedForwardTicketData.dropoff_specified_address,
        init_note: _ctx.specifiedForwardTicketData.dropoff_note,
        onChangedAddress: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeAddress($event))),
        onChangedNote: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeNote($event)))
      }, null, 8, ["upperText", "lowerText", "labelText", "init_is_checked", "init_address", "init_note"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.transportations, (transportation) => {
            return (_openBlock(), _createBlock(_component_TransportationItemComponent, {
              key: transportation.id,
              "map-center": _ctx.mapCenter,
              placeholder: _ctx.roundTrip ? 'select' : 'order_now',
              "is-round-trip": _ctx.roundTrip,
              transportation: transportation,
              onSelectTransportation: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSelectTransportation($event)))
            }, null, 8, ["map-center", "placeholder", "is-round-trip", "transportation"]))
          }), 128))
    ])
  ]))
}